var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('eComplaintsTable',_vm._b({on:{"snackbar-msg":function($event){return _vm.mxfSendParent('snackbar-msg', $event)},"go-to-detail":_vm.fGoToDetail,"reload-kpis":_vm.fReloadKpis}},'eComplaintsTable',_vm.cProp,false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }